"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _startCase2 = _interopRequireDefault(require("lodash/startCase"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _set2 = _interopRequireDefault(require("lodash/set"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _admin = require("../../../reducers/admin");
var _getResourceCenter = _interopRequireDefault(require("../../../helpers/getResourceCenter"));
var _index = _interopRequireWildcard(require("./FormCertificate/index.js"));
var _index2 = _interopRequireWildcard(require("./FormCourse/index.js"));
var _index3 = _interopRequireWildcard(require("./FormCourseDescription/index.js"));
var _FormCourseEval = _interopRequireWildcard(require("./FormCourseEval"));
var _index4 = _interopRequireWildcard(require("./FormFinalTest/index.js"));
var _index5 = _interopRequireWildcard(require("./FormRegistration/index.js"));
var _FormResources = _interopRequireWildcard(require("./FormResources"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var formCouplers = [_index3.formCoupler, _index5.formCoupler, _index2.formCoupler, _index4.formCoupler, _FormCourseEval.formCoupler, _index.formCoupler, _FormResources.formCoupler];
var setDefaultsWhereNoValue = function setDefaultsWhereNoValue(obj, defaults) {
  for (var _i = 0, _Object$keys = Object.keys(defaults); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    if (obj[key] === null || obj[key] === undefined) {
      obj[key] = defaults[key];
    }
  }
};

// recursively set defaults for nested structures
var _setDefaultWhereNoValueDeep = function setDefaultWhereNoValueDeep(initialValues, obj, path) {
  if (Array.isArray(obj)) {
    obj.forEach(function (nestedObj, i) {
      _setDefaultWhereNoValueDeep(initialValues, nestedObj, "".concat(path, "[").concat(i, "]"));
    });
  } else if (_typeof(obj) === 'object' && obj !== null) {
    Object.keys(obj).forEach(function (key) {
      _setDefaultWhereNoValueDeep(initialValues, obj[key], "".concat(path, ".").concat(key));
    });
  } else {
    var val = (0, _get2["default"])(initialValues, path, '');
    if (val === null) {
      (0, _set2["default"])(initialValues, path, '');
    }
  }
};

/* Main Component */
var CourseWrapperModalContents = function CourseWrapperModalContents(props) {
  var assignmentData = props.assignmentData,
    assignmentTerm = props.assignmentTerm;
  var _useState = (0, _react.useState)('courseDescription'),
    _useState2 = _slicedToArray(_useState, 2),
    currTab = _useState2[0],
    setCurrTab = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    errorTabs = _useState4[0],
    setErrorTabs = _useState4[1];
  var dispatch = (0, _reactRedux.useDispatch)();
  var existingCourseSettings = assignmentData.settings && assignmentData.settings.navigationSettings || {};
  var getInitialValues = function getInitialValues() {
    var assignmentSettings = assignmentData.settings;
    var initialValues = {};
    formCouplers.forEach(function (formCoupler) {
      initialValues[formCoupler.key] = _objectSpread({}, existingCourseSettings[formCoupler.key]);
      setDefaultsWhereNoValue(initialValues[formCoupler.key], formCoupler.initialValues);
    });
    _setDefaultWhereNoValueDeep(initialValues, initialValues.courseDescription, 'courseDescription');
    _setDefaultWhereNoValueDeep(initialValues, initialValues.certificate, 'certificate');
    var certPath = 'navigationSettings.certificate';
    if (!(0, _get2["default"])(assignmentSettings, "".concat(certPath, ".certificates"))) {
      var courseName = (0, _get2["default"])(assignmentSettings, "".concat(certPath, ".courseName"), assignmentData.label);
      if (courseName) {
        (0, _set2["default"])(initialValues, 'certificate.certificates[0].courseName', courseName);
      }
      var freeText = (0, _get2["default"])(assignmentSettings, "".concat(certPath, ".freeText"));
      if (freeText) {
        (0, _set2["default"])(initialValues, 'certificate.certificates[0].freeText', freeText);
      }
      var backgroundId = (0, _get2["default"])(assignmentSettings, "".concat(certPath, ".backgroundId"));
      if (backgroundId) {
        (0, _set2["default"])(initialValues, 'certificate.certificates[0].backgroundId', backgroundId);
      }
    }
    if (initialValues.course.options.length === 0) {
      initialValues.course.options = assignmentData.currentSurveylistList.surveyList.filter(function (survey) {
        return !survey.archived;
      }).map(function (survey) {
        return survey.surveyHandle;
      });
    }
    return initialValues;
  };
  var validate = function validate(values) {
    var errors = {};
    var newErrorTabs = [];
    formCouplers.forEach(function (formCoupler) {
      if (!formCoupler.validate(values, errors)) {
        newErrorTabs.push(formCoupler.errorTab);
      }
    });
    setErrorTabs((0, _uniq2["default"])(newErrorTabs));
    return errors;
  };
  var onSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(values, formikBag) {
      var isSavingOnly,
        isSuccess,
        _args = arguments;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            isSavingOnly = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
            formikBag.setSubmitting(true);
            _context.n = 1;
            return dispatch((0, _admin.updateQuestSettings)(assignmentData.assignmentId, _objectSpread(_objectSpread({}, assignmentData.settings), {}, {
              navigationSettings: _objectSpread(_objectSpread({}, existingCourseSettings), values)
            })));
          case 1:
            isSuccess = _context.v;
            if (isSuccess) {
              (0, _cccisdNotification["default"])("".concat(assignmentTerm, " successfully updated"));
              if (isSavingOnly) {
                formikBag.resetForm(values);
                formikBag.setSubmitting(false);
              } else {
                props.closeModal();
              }
            } else {
              (0, _cccisdNotification["default"])({
                type: 'danger',
                message: "".concat(assignmentTerm, " failed to update")
              });
            }
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function onSubmit(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var initialValues = getInitialValues();
  var errorInOtherTab = !!errorTabs.filter(function (t) {
    return t !== currTab;
  }).length;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "nav nav-tabs"
  }, /*#__PURE__*/_react["default"].createElement("li", {
    role: "presentation",
    className: "nav-item"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "",
    className: (0, _classnames["default"])('nav-link', currTab === 'courseDescription' && 'active'),
    onClick: function onClick(e) {
      e.preventDefault();
      setCurrTab('courseDescription');
    }
  }, "Course Description")), /*#__PURE__*/_react["default"].createElement("li", {
    role: "presentation",
    className: "nav-item"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "",
    className: (0, _classnames["default"])('nav-link', currTab === 'course' && 'active'),
    onClick: function onClick(e) {
      e.preventDefault();
      setCurrTab('course');
    }
  }, "Course")), /*#__PURE__*/_react["default"].createElement("li", {
    role: "presentation",
    className: "nav-item"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "",
    className: (0, _classnames["default"])('nav-link', currTab === 'postCourse' && 'active'),
    onClick: function onClick(e) {
      e.preventDefault();
      setCurrTab('postCourse');
    }
  }, "Post Course")), /*#__PURE__*/_react["default"].createElement("li", {
    role: "presentation",
    className: "nav-item",
    style: Object.keys((0, _getResourceCenter["default"])()).length || initialValues.resources.toggle ? {} : {
      display: 'none'
    }
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "",
    className: (0, _classnames["default"])('nav-link', currTab === 'resources' && 'active'),
    onClick: function onClick(e) {
      e.preventDefault();
      setCurrTab('resources');
    }
  }, "Resources"))), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    initialValues: initialValues,
    onSubmit: onSubmit,
    validate: validate,
    render: function render(formProps) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, {
        className: _style["default"].modalContent
      }, currTab === 'courseDescription' && /*#__PURE__*/_react["default"].createElement(_index3["default"], {
        formProps: formProps
      }), currTab === 'course' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_index5["default"], {
        assignmentData: assignmentData,
        formProps: formProps
      }), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement(_index2["default"], {
        assignmentData: assignmentData,
        formProps: formProps
      })), currTab === 'postCourse' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_index4["default"], {
        assignmentData: assignmentData,
        toggle: formProps.values.finalTest.toggle,
        values: formProps.values,
        formProps: formProps
      }), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement(_FormCourseEval["default"], {
        assignmentData: assignmentData,
        toggle: formProps.values.courseEval.toggle,
        formProps: formProps
      }), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement(_index["default"], {
        formProps: formProps,
        toggle: formProps.values.certificate.toggle,
        currentCertificates: formProps.values.certificate.certificates,
        currentCompletionText: formProps.values.certificate.completionText,
        currentTabName: formProps.values.certificate.tabName,
        staticCertificateId: existingCourseSettings.certificate && existingCourseSettings.certificate.staticCertificateId
      })), currTab === 'resources' && /*#__PURE__*/_react["default"].createElement(_FormResources["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "mt-3 text-end"
      }, errorInOtherTab && /*#__PURE__*/_react["default"].createElement("div", {
        className: "alert alert-danger",
        role: "alert",
        style: {
          margin: '0px',
          padding: '6px',
          "float": 'left'
        }
      }, "There are errors to resolve on other tabs:", ' ', errorTabs.filter(function (t) {
        return t !== currTab;
      }).map(function (t) {
        return (0, _startCase2["default"])(t);
      }).join(', ')), /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        className: "btn btn-primary me-2",
        title: formProps.isSubmitting ? 'Saving...' : 'Submit',
        isLoading: formProps.isSubmitting,
        onClick: formProps.submitForm,
        isDisabled: formProps.isSubmitting
      }), /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        className: "btn btn-warning",
        title: formProps.isSubmitting ? 'Saving...' : 'Save Progress',
        isLoading: formProps.isSubmitting,
        onClick: function onClick() {
          return onSubmit(formProps.values, formProps, true);
        },
        isDisabled: formProps.isSubmitting || errorTabs.length > 0 || !formProps.dirty
      })));
    }
  }));
};
CourseWrapperModalContents.propTypes = {
  assignmentData: _propTypes["default"].object,
  assignmentTerm: _propTypes["default"].string,
  closeModal: _propTypes["default"].func
};
CourseWrapperModalContents.defaultProps = {
  assignmentTerm: 'Quest'
};
var _default = exports["default"] = CourseWrapperModalContents;